export function configValue(key) {
  const element = document.head.querySelector(`meta[name=${key}]`);
  return element && element.content;
}
